import {Vacation} from './types';
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import HttpClient from '../../api/api';

export interface VacationsState {
    items: Vacation[];
}

const initialState: VacationsState = {
    items: []
}

export const getVacation = createAsyncThunk(
    'vacations/get',
    async (id: number) => {
        const response = await HttpClient.vacationsApi.get<Vacation>(id);
        return response.data;
    }
)

export const getVacations = createAsyncThunk(
    'vacations/get-many',
    async (args: { dateFrom: string, dateTo: string, employees: Array<number>, states: Array<number> }) => {
        const response = await HttpClient.vacationsApi.getMany<Vacation[]>(args.dateFrom, args.dateTo, args.employees, args.states);
        return response.data;
    }
)

export const createVacation = createAsyncThunk(
    'vacations/create',
    async (vacation: Vacation) => {
        const response = await HttpClient.vacationsApi.create<Vacation>(vacation);
        return response.data;
    }
)

export const updateVacation = createAsyncThunk(
    'vacations/update',
    async (vacation: Vacation) => {
        const response = await HttpClient.vacationsApi.update<Vacation>(vacation.id, vacation);
        return response.data
    }
)

export const cancelVacation = createAsyncThunk(
    'vacations/cancel',
    async (vacationId: number) => {
        const response = await HttpClient.vacationsApi.cancel<Vacation>(vacationId);
        return response.data;
    }
)

export const declineVacation = createAsyncThunk(
    'vacations/decline',
    async (vacationId: number) => {
        const response = await HttpClient.vacationsApi.decline<Vacation>(vacationId);
        return response.data;
    }
)

export const approveVacation = createAsyncThunk(
    'vacations/approve',
    async (args: { vacationId: number, force: boolean }) => {
        const response = await HttpClient.vacationsApi.approve<Vacation>(args.vacationId, args.force);
        return response.data;
    }
)

const vacationsSlice = createSlice({
    name: 'vacations',
    initialState,
    reducers: {
        clearVacations: (state) => {
            state.items = initialState.items;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getVacations.fulfilled, (state, action) => {
            state.items = action.payload;
        })
        builder.addCase(updateVacation.fulfilled, (state, action) => {
            if (state.items && state.items.length > 0) {
                const index = state.items.findIndex((x) => x.id === action.payload.id);
                if (index != -1) {
                    state.items[index] = action.payload;
                    return;
                }
            }

            state.items = [...state.items, action.payload];
        });
        builder.addCase(cancelVacation.fulfilled, (state, action) => {
            if (state.items && state.items.length > 0) {
                const index = state.items.findIndex((x) => x.id === action.payload.id);
                if (index != -1) {
                    state.items[index] = action.payload;
                    return;
                }
            }

            state.items = [...state.items, action.payload];
        });
        builder.addCase(declineVacation.fulfilled, (state, action) => {
            if (state.items && state.items.length > 0) {
                const index = state.items.findIndex((x) => x.id === action.payload.id);
                if (index != -1) {
                    state.items[index] = action.payload;
                    return;
                }
            }

            state.items = [...state.items, action.payload];
        });
        builder.addCase(approveVacation.fulfilled, (state, action) => {
            if (state.items && state.items.length > 0) {
                const index = state.items.findIndex((x) => x.id === action.payload.id);
                if (index != -1) {
                    state.items[index] = action.payload;
                    return;
                }
            }

            state.items = [...state.items, action.payload];
        });
        builder.addCase(getVacation.fulfilled, (state, action) => {
            if (state.items && state.items.length > 0) {
                const index = state.items.findIndex((x) => x.id === action.payload.id);
                if (index != -1) {
                    state.items[index] = action.payload;
                    return;
                }
            }
            state.items = [...state.items, action.payload];
        })
        builder.addCase(createVacation.fulfilled, (state, action) => {
            state.items.push(action.payload)
        });
    }
})

export const { clearVacations } = vacationsSlice.actions;

export default vacationsSlice.reducer;
